<template>
  <div class="container">
    <div class="left">
      <el-tree
        :data="dataTree"
        ref="tree"
        :props="defaultProps"
        default-expand-all
        :expand-on-click-node="false"
        :highlight-current="true"
        @node-click="handleNodeClick"
        node-key="id"
        :current-node-key="currentNodekey"
        :default-expanded-keys="expandedkeys"
      ></el-tree>
    </div>
    <div class="left-2">
      <p class="main-left-p">
        <span>共有文件夹：{{ folderList.length }}</span>
        <el-button
          size="mini"
          type="text"
          @click="addEntFun"
          style="font-size: 0.8vw"
          >添加文件夹</el-button
        >
      </p>
      <div class="main-left-list">
        <ul>
          <li
            v-for="(item, index) in folderList"
            :key="index"
            :class="{ curEnt: folderId == item.id }"
            @click="getEntId(item)"
          >
            <i class="el-icon-folder"></i>
            <div class="unit-name color4 nowrap">
              <p :title="item.filesName" class="nowrap">{{ item.filesName }}</p>
            </div>
            <div class="unit-ctl color4" style="display:flex;">
              <el-button type="text" @click="editFolder(item)">编辑</el-button>
              <el-button type="text" style="color: red" @click="delFolder(item)"
                >删除</el-button
              >
            </div>
          </li>
        </ul>
      </div>
      <!-- <div class="active">施工前期资料</div>
      <div>施工过程资料</div>
      <div>施工验收资料</div> -->
    </div>
    <div class="right">
      <div class="onload">
        <el-upload
          class="upload-demo"
          v-if="folderId != ''"
          v-bind:action="uploadUrl"
          :headers="uploadHead"
          :data="{ type: 225 }"
          :show-file-list="false"
          :on-success="fileSuccess"
        >
          <el-button size="small" type="primary" class="primary"
            >点击上传</el-button
          >
        </el-upload>
      </div>
      <el-table
        :data="tableDataEnd"
        height="70vh"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F7F9', color: '#909399' }"
      >
        <template slot="empty">
          <p>{{ dataText }}</p>
        </template>
        <el-table-column label="序号" type="index" width="80"></el-table-column>
        <el-table-column label="文件名称">
          <template slot-scope="scope">
            <!--  <router-link :to="'/teamWorker/'+scope.row.id" class="color5" :title="scope.row.name">{{scope.row.name}}</router-link> -->
            <div
              style="
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
              "
              
            >
              <img
                v-if="scope.row.fileFormat == '0'"
                src="../../assets/image/office/undefined.png"
                style="width: 5vh; height: 5vh"
              />
              <img
                v-else-if="scope.row.fileFormat == '1'"
                src="../../assets/image/office/word.png"
                style="width: 5vh; height: 5vh"
              />
              <img
                v-else-if="scope.row.fileFormat == '2'"
                src="../../assets/image/office/excel.png"
                style="width: 5vh; height: 5vh"
              />
              <img
                v-else-if="scope.row.fileFormat == '3'"
                src="../../assets/image/office/pdf.png"
                style="width: 5vh; height: 5vh"
              />
              <img
                v-else-if="scope.row.fileFormat == '4'"
                src="../../assets/image/office/photo.png"
                style="width: 5vh; height: 5vh"
              />
              <img
                v-else
                src="../../assets/image/office/undefined.png"
                style="width: 5vh; height: 5vh"
              />
              <span style="padding-left: 1vw">{{ scope.row.filesName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="大小" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.filseCapacity }}B</span>
          </template>
        </el-table-column>
        <el-table-column label="上传日期" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleDown(scope.$index, scope.row)"
              >下载</el-button
            >
             <el-button size="mini" @click="showFile(scope.row)" type="primary"
              >查看</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="entTitle"
      :visible.sync="entVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      width="30%"
    >
      <el-form
        :model="addFolder"
        ref="addFolder"
        :rules="rules"
        label-width="200px"
        label-position="right"
        class="joinEnt"
      >
        <el-form-item label="文件名：" prop="fileName">
          <el-input
            v-model="addFolder.filesName"
            autocomplete="off"
            style="width: 220px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="entVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddFolder('addFolder')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      entVisible: false,
      dataText: '',
      groupId: '',
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      dataTree: [],
      defaultProps: {
        children: 'list',
        label: 'name',
      },
      folderList: [],
      addFolder: {
        filesType: '1',
        type: '8',
        filesName: '',
        groupId: '',
        id: '',
      },
      folderId: '',
      uploadUrl: base.url + '/upload/uploadPhoto', //上传地址
      uploadHead: {
        //上传接口header
        accessToken: this.$store.state.token,
      },
      tableDataEnd: [],
    }
  },
  mounted() {
    this.getAll()
  },
  methods: {
    //获取所有项目
    getAll() {
      var that = this
      myHttp
        .getPageListPro({
          entId: util.session.get('groupId'),
          joinType: '3',
        })
        .then(function (resp) {
          console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.entOfficeProjectMenu || []
            for (var i = 0; i < list.length; i++) {
              if (list[i].list.length > 0 && that.groupId == '') {
                that.groupId = list[i].list[0].id
                that.currentNodekey = list[i].list[0].id
                that.expandedkeys.push(list[i].list[0].id)
                console.log(that.expandedkeys);
                that.$nextTick(() => {
                  that.$refs.tree.setCurrentKey(that.currentNodekey)
                })
                // that.getData()
                that.getFolder()
              }
            }
            that.dataTree = list
            console.log(list)
          }
        })
    },
    //点击树形结构
    handleNodeClick(data) {
      if (data.list) {
        return
      } else {
        this.groupId = data.id
        this.addFolder.groupId = data.id
        this.getFolder()
        this.getData()
      }
    },
    //获取文件夹
    getFolder() {
      var that = this
      myHttp
        .selectFolder({
          filesType: '1',
          type: '8',
          groupId: this.groupId,
          userType: util.session.get('roleId'),
        })
        .then(function (resp) {
          console.log(resp)
          if (resp.data.code == '200') {
            var list = resp.data.data.Files || []
            if (list.length > 0) {
              that.folderId = list.length > 0 ? list[0].id : ''
              that.getData()
            } else {
              that.dataText = '暂无数据'
            }
            that.folderList = list
          } else {
          }
        })
    },
    addEntFun() {
      this.entVisible = true
      this.addFolder.filesName = ''
      this.addFolder.id = ''
      this.entTitle = '添加文件夹'
    },
    //添加或者修改文件夹
    sumbitAddFolder(formName) {
      var that = this

      this.addFolder.groupId = this.groupId
      this.addFolder.userType = util.session.get('roleId')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addFolder.id == '') {
            this.addFolder.createBy = util.session.get('user').id
            myHttp.addFolderFiles(this.addFolder).then(function (resp) {
              console.log(resp)
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.entVisible = false
                that.getFolder()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          } else {
            this.addFolder.updateBy = util.session.get('user').id
            myHttp.updateFiles(this.addFolder).then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('修改成功')
                that.entVisible = false
                that.getFolder()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    //选择展示的文件夹
    getEntId(row) {
      this.folderId = row.id
      this.getData()
    },

    /***
     * 获取文件
     */
    getData() {
      var that = this
      // console.log(this.joinEntId)
      myHttp
        .selectDocument({
          id: this.folderId,
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.Files || []
            for (var i = 0; i < list.length; i++) {
              list[i].fileFormat =
                list[i].filesName && list[i].filesName != ''
                  ? that.getImg(list[i].filesName)
                  : '0'
            }
            that.tableDataEnd = list
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        })
    },
    //上传成功
    fileSuccess(res, file, opt) {
      if (res.code == 200) {
        // console.log(res)
        // console.log(file)
        var obj = {
          filesType: '2',
          type: '1',
          filesName: file.name,
          filesAddress: res.data.saveUrls,
          filseCapacity: file.size,
          groupId: this.groupId,
          userType: util.session.get('roleId'),
          parentId: this.folderId,
          createBy: util.session.get('user').id,
        }
        var that = this
        myHttp.addFolderFiles(obj).then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('添加成功')
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    //获取图片
    getImg(url) {
      // 1:word   2:excel    3:pdf     4:img   5:undefined
      var result = ''
      var list = url.split('.')
      var str = list[list.length - 1]
      if (base.docType.indexOf(str) >= 0) {
        result = '1'
      } else if (base.imgType.indexOf(str) >= 0) {
        result = '4'
      } else if (base.excelType.indexOf(str) >= 0) {
        result = '2'
      } else if (base.pdfType.indexOf(str) >= 0) {
        result = '3'
      } else {
        result = '5'
      }
      return result
    },
    //下载
    handleDown(index, row) {
      // console.log(base.httpCtx + row.filesAddress);
      window.open(base.httpCtx + row.filesAddress)
    },
    //展示
    showFile(row) {
      var that = this
      window.open(
        base.fileView + '/onlinePreview?url=' + encodeURIComponent(base.httpCtx + row.filesAddress), '_blank'
      )
    },
    //删除文件
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp
            .deleteFiles({
              id: row.id,
              updateBy: util.session.get('user').id,
            })
            .then(function (resp) {
              if (resp.data.code == '200') {
                that.$message({
                  type: 'success',
                  message: '删除成功!',
                })
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch((err) => {})
    },
    //编辑文件夹
    editFolder(obj) {
      this.entVisible = true
      this.addFolder.filesName = obj.filesName
      this.addFolder.id = obj.id
      this.entTitle = '修改文件夹'
    },
    //删除文件夹
    delFolder(obj) {
      var that = this
      this.$confirm('此操作将永久删除该文件夹及其中的文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        myHttp
          .deleteFiles({
            id: obj.id,
            updateBy: util.session.get('user').id,
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getFolder()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      })
    },
  },
}
</script>

<style scoped>
@import '../../assets/css/common.css';
.container {
  height: 100%;
  padding: 1vh 1vw;
  display: flex;
}
.left,
.left-2 {
  width: 15vw;
  height: 100%;
  border-radius: 10px;
  background-color: #fff;
  margin-right: 1vw;
  padding: 1vw;
}
.left-2 > div {
  padding: 0.6vw 0;
  cursor: pointer;
}
.right {
  width: 55vw;
  height: 100%;
  background-color: #fff;
  padding: 1vh 1vw;
}
.active {
  background-color: #eee;
}
.onload {
  text-align: right;
  padding-bottom: 2vh;
}
.main-left-p {
  width: 100%;
  height: 7%;
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  padding: 0 1vh;
}
.main-left-list {
  width: 100%;
  height: 85%;
  position: relative;
  overflow: auto;
}
.main-left-list li {
  width: 100%;
  height: 5vh;
  position: relative;
  padding: 1vh 2vh;
  display: flex;
  align-content: center;
  align-items: center;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
.nowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.curEnt {
  background: #e7f1fb;
}
.curEnt i,
.curEnt p {
  color: #5a87f9;
}
</style>